module.exports = __webpack_public_path__ + "static/media/show-what-you-learned.70f36e24.gif";


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/show-what-you-learned.gif
// module id = 323
// module chunks = 0